<template>
    <div class="fill-height w-100">
        <v-banner v-if="$route.query && $route.query.invitation_target" class="mb-5" single-line>
            <v-avatar slot="icon" color="white" size="50">
                <v-icon large color="success">check_circle</v-icon>
            </v-avatar>
            <span class="subtitle-1 font-weight-medium">{{ invitationText }}</span>
            <template v-if="!isOrgInvite" v-slot:actions>
                <v-btn @click="$router.push({ path: $route.query.invitation_target })" color="primary" elevation="0">Open space</v-btn>
            </template>
        </v-banner>
        <v-snackbar v-if="validOrgRequests.length" v-model="notificationsSnackbar" absolute bottom left :timeout="-1">
            <div class="d-flex justify-space-between align-center">
                <v-subheader>Important Notifications</v-subheader>
                <v-btn @click="notificationsSnackbar = false" icon><v-icon>clear</v-icon></v-btn>
            </div>
            <v-list-item>
                <v-list-item-icon>
                    <v-icon dark>notification_important</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ validOrgRequests.length }} requests require approval</v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                    <v-btn :to="{ name: 'user-requests' }" color="primary" small>Review</v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-snackbar>
        <v-card flat color="transparent" class="fill-height">
            <HomeSpacesPanel />
            <TheOrgSelectorDialog v-if="!userMetadata.latestOrg" />
        </v-card>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { isAdminRole } from '@/utils'
import '@/sass/signup.scss'

// const HomeDashboardCard = () => import('../components/HomeDashboardCard.vue')
// const DashboardQuickAccessCard = () => import('../components/DashboardQuickAccessCard.vue')
// const DashboardError = () => import('@/components/DashboardError.vue')
const HomeSpacesPanel = () => import('@/components/HomeSpacesPanel.vue')
const TheOrgSelectorDialog = () => import('@/components/TheOrgSelectorDialog.vue')

export default {
    components: { /* HomeDashboardCard, */ HomeSpacesPanel, TheOrgSelectorDialog /* DashboardQuickAccessCard, DashboardError */ },
    data() {
        return {
            notificationsSnackbar: true
        }
    },
    methods: {
        fetchRequests() {
            const spacesWithAdminRole = this.spacesWithPrimarySnapshots.filter(space => isAdminRole(space.space_role))
            if (this.isOrgManager || spacesWithAdminRole.length) {
                this.$store.dispatch('userStore/fetchUserToApproveRequests')
            }
        }
    },
    computed: {
        ...mapState(['fetchingOrgs', 'userMetadata', 'fetchingUserInfo']),
        ...mapState('appStore', ['fetchingApps']),
        ...mapState('orgStore', ['spacesWithPrimarySnapshots']),
        ...mapGetters('orgStore', ['isOrgManager']),

        validOrgRequests() {
            const requests = this.$store.getters['userStore/validRequests']
            return requests.filter(request => request.oid && request.oid.toString() === this.$route.params.oid.toString())
        },
        isOrgInvite() {
            return this.$route.query.invitation_target.split('/').indexOf('dashboard') > -1
        },
        invitationText() {
            if (this.isOrgInvite) {
                return 'An invitation has recently been accepted and you can now start exploring the organization.'
            } else {
                return 'An invitation has been recently accepted and you can now start exploring the space.'
            }
        },
        allLoaded() {
            return !this.fetchingOrgs && !this.fetchingApps && !this.fetchingUserInfo
        }
    },
    watch: {
        allLoaded(loaded) {
            if (loaded) {
                window.Intercom?.('shutdown')
            }
        }
    },
    created() {
        this.fetchRequests()
        this.$store.dispatch('appStore/fetchNodePools')
    }
}
</script>
